module.exports = __webpack_public_path__ + "img/pwp-ic-back-new.svg";